import { Subject, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { MessageParameterQuote, MessageWebFeeder } from '../models/message-webfeeder';
import { WebfeederSubscribeTypeEnum } from '../enums/webfeeder';


export class SubscriptionRegister {
  subject?: BehaviorSubject<any>;
  parameters?: any;
  format?: any;
  oldMessage: any
  currentMessage: any
  private _connections: number = 0;

  incrementConnection() {
    this._connections++;
  }

  decrementConnection() {
    this._connections = (this._connections > 0) ? this._connections - 1 : 0;
  }

  getCountConnections() {
    return this._connections;
  }

}

@Injectable({
  providedIn: 'root'
})
export class WebfeederSubscriptionsService {
  private subscriptions: Map<string, SubscriptionRegister> = new Map<string, SubscriptionRegister>();
  constructor() { }

  getAllMessageToSubscribe() {
    let msgsToSubscribe = [];
    for (const subscriptionId in this.subscriptions) {
      const subscription = this.subscriptions.get(subscriptionId);

      const messageParameter = new MessageParameterQuote();
      messageParameter.subsbribetype = WebfeederSubscribeTypeEnum.SUBSCRIBE; // Subscribe
      messageParameter.filter = subscription?.parameters.filter;
      messageParameter.delay = subscription?.parameters.delay;

      const dataMsg: MessageWebFeeder = new MessageWebFeeder();
      dataMsg.token = '';
      dataMsg.module = subscription?.parameters?.module;
      dataMsg.service = subscription?.parameters?.service;
      dataMsg.parameterGet = subscription?.parameters?.parameterGet;

      dataMsg.parameters = messageParameter;
      msgsToSubscribe.push(dataMsg);
    }

    return msgsToSubscribe;
  }

  getAllMessageToUnsubscribe() { }

  addSubscription(key: string, parameters: any, format: string[] = []) {
    if (this.subscriptions.has(key)) {
      this.subscriptions.get(key)?.incrementConnection()
    } else {
      let subscriptionRegister = new SubscriptionRegister();
      subscriptionRegister.format = format;
      subscriptionRegister.parameters = parameters;
      subscriptionRegister.subject = new BehaviorSubject(null);
      subscriptionRegister.incrementConnection();
      this.subscriptions.set(key, subscriptionRegister)
    }
  }

  removeSubscription(key: string) {
    let subscription = this.subscriptions.get(key);
    if (!!subscription) {
      subscription.decrementConnection()
      if (subscription.getCountConnections() <= 0) {
        subscription.subject?.unsubscribe();
        delete subscription.subject;
        this.subscriptions.delete(key)
      }
    }
  }

  getSubscription(key: string): SubscriptionRegister | undefined {
    return this.subscriptions.get(key)
  }

  hasSubscription(key: string): boolean {
    return this.subscriptions.has(key)
  }

  logSubscriptionKeys(): void {
    // Verifica se há alguma chave no mapa
    if (this.subscriptions.size === 0) {
      console.log('No keys in subscriptions');
      return;
    }

    // Loga as chaves usando keys() e iterando com for...of
    console.log('Subscription keys:');
    for (const key of this.subscriptions.keys()) {
      console.log(atob(key));
    }

    // Alternativa: transformar em um array e logar diretamente
    console.log('Subscription keys as array:', Array.from(this.subscriptions.keys()));
  }
}
